import { render, staticRenderFns } from "./header.vue?vue&type=template&id=0a11b5e0&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=0a11b5e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a11b5e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a11b5e0')) {
      api.createRecord('0a11b5e0', component.options)
    } else {
      api.reload('0a11b5e0', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=0a11b5e0&scoped=true&", function () {
      api.rerender('0a11b5e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/components/header.vue"
export default component.exports